import featuresRoutes from '@/features/features.routes';
import { LoginComponent } from '@/core/auth/login/login';
import { Routes } from '@angular/router';

export const appRoutes: Routes = [{ path: 'login', component: LoginComponent }, ...featuresRoutes];
export default appRoutes;
